import { useEffect } from 'react';
import useRequestEmailVerification from 'components/Hooks/useRequestEmailVerification';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { makeSelectAuth } from 'containers/Auth/selectors';
import useIsEmailVerified from 'components/Hooks/useIsEmailVerified';
import useIsAuthPath from 'components/Hooks/useIsAuthPath';

function useAccountVerification() {
  const location = useLocation();
  const auth = useSelector(makeSelectAuth());
  const { verified, isEnabled, requireVerification } = useIsEmailVerified();
  const isAuthenticationPage = useIsAuthPath();
  const requestEmailVerification = useRequestEmailVerification();

  useEffect(() => {
    const token =
      auth &&
      auth.isLoaded &&
      !auth.isEmpty &&
      _get(auth, 'stsTokenManager.accessToken');

    if (
      isEnabled &&
      requireVerification &&
      !verified &&
      !isAuthenticationPage &&
      token
    ) {
      // Pass current location as redirect so user returns to this page after verification
      requestEmailVerification(location.pathname + location.search);
    }
  }, [
    requestEmailVerification,
    isAuthenticationPage,
    isEnabled,
    requireVerification,
    verified,
    auth,
    location,
  ]);
}

export default useAccountVerification;
